import * as React from 'react';

import { getPrivacyPolicyUrl } from './utils';
import { getPersonalDataAgreementUrl } from './utils/ getPersonalDataAgreementUrl';
import { PersonalAgreement } from '../../../components/RequestFormV2/PersonalAgreement';
import { useApplicationContext } from '../../../utils/applicationContext';

export const PersonalAgreementContainer = () => {
  const { config } = useApplicationContext();

  const policyUrl = getPrivacyPolicyUrl(config);
  const personalDataAgreement = getPersonalDataAgreementUrl(config);

  return <PersonalAgreement policyUrl={policyUrl} personalDataAgreement={personalDataAgreement} />;
};
